import React from 'react';
import { Space, Button, DatePicker } from 'antd';
import { Label } from '../Layouts';
import { SearchSystemLogsParams } from '../../api/logs';
import ModuleActionSelect from '../common/ModuleActionSelect';
import UserLookup from '../common/UserLookup';
import dayjs from 'dayjs'

export type SearchParams = SearchSystemLogsParams;

const LogFilter: React.FC<{ onSearch: () => void, values: SearchParams, onChange: (v: SearchParams) => void, }> =
    ({ values: params, onChange: setParams, onSearch }) => {
        return (
            <Space>
                <Label>
                    <Label>用户</Label>
                    <UserLookup
                        style={{ width: 180 }}
                        allowClear value={params.userId} onChange={userId => {
                            setParams({
                                ...params,
                                userId
                            })
                        }} />
                </Label>
                <Label>
                    <Label>模块和行为</Label>
                    <ModuleActionSelect
                        placeholder='请选择'
                        style={{ minWidth: 280 }}
                        allowClear value={[params.module, params.action].filter(Boolean)} onChange={([module, action]) => {
                            setParams({
                                ...params,
                                action,
                                module
                            })
                        }} />
                </Label>

                <Label>
                    <Label>创建时间</Label>
                    <DatePicker.RangePicker
                        needConfirm={false}
                        showTime
                        value={[
                            params.createTimeQueryStartDate ? dayjs(params.createTimeQueryStartDate) : null,
                            params.createTimeQueryEndDate ? dayjs(params.createTimeQueryEndDate) : null,
                        ]}
                        onChange={(_, [createTimeQueryStartDate, createTimeQueryEndDate]) => {
                            setParams({
                                ...params,
                                createTimeQueryStartDate: createTimeQueryStartDate || undefined,
                                createTimeQueryEndDate: createTimeQueryEndDate || undefined
                            })
                        }}
                        placeholder={['创建时间(起)', '创建时间(止)']} />
                </Label>
                <Button onClick={onSearch} style={{ marginTop: '1.4em' }} type='primary'>查询</Button>
            </Space>
        );
    }

export default LogFilter;